<app-menu-bar></app-menu-bar>
<app-sidebar></app-sidebar>


<div id="main-wrapper">
  <div id="main-content-wrapper" class="content-wrapper">
    <router-outlet></router-outlet>
  </div>
</div>
